import React, {useEffect, useContext} from 'react';
import styles from './info.module.css';
import {sensorFailedItem} from '../../../App';
import CommonMenu from '../../menu/commonMenu';
import {useMenu} from '../../../hooks/useMenu';
import useKeyPress from '../../../hooks/useKeyPress';
import Acknowledge from '../acknowledge';
import SubMenuView from '../../views/subMenuView';
import MenuContext from '../../../context/menuContext';
import CommandsContext from '../../../context/commandsContext';

function Info({onExit}) {
  const {topText, top, infoContent} = styles;
  const {
    setShowAck,
    setShowInfo,
    setsensorError,
    showAck,
    showInfo,
    sensorError,
    onComponent,
    info,
    alert,
    setInfo,
  } = useContext(MenuContext);

  const leftPress = useKeyPress('ArrowLeft');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
  }, [leftPress]);

  useEffect(() => {
    onUpdateCommands(commands => ({...commands}));
  }, []);

  // useEffect(() => {
  //   if (!leftPress) return;
  //   onComponent(<Acknowledge />);
  // }, [leftPress]);

  useEffect(() => {
    if (alert === false) {
      onExit();
    }
  }, [alert]);

  return (
    <SubMenuView
      title="Sensor Failed"
      menuItems={sensorFailedItem}
      content="Resolve the following conditions"
      onLeftCallback={() => onComponent(<Acknowledge />)}
    />
  );
}

export default Info;
